import { russianToEnglishDict } from '../consts';

export const convertCodeChar = (string: string): string => {
  if (/[а-яёА-ЯЁ]/.test(string))
    return string
      .split('\x1D')
      .map((str) => {
        const chars = str.split('');

        return chars.reduce((acc, char) => {
          const convertedChar = russianToEnglishDict[char];

          if (convertedChar) {
            return acc + convertedChar;
          }
          return acc + char;
        }, '');
      })
      .join('\x1D');

  return string;
};
